import styled from '@emotion/styled'
import { ServerSideMetricsDetailByTime } from '@pubstack/common/src/analytics/query'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import { Timezone } from '@pubstack/common/src/timezone'
import { DateTime } from 'luxon'
import { FunctionComponent } from 'react'
import { LazyVisible } from '~/components/LazyVisible'
import { WidgetProps } from '~/components/Widget'
import { ServerSideWidgetCPM } from '~/modules/analytics/server-side/details/ServerSideWidgetCPM'
import { ServerSideWidgetFunnel } from '~/modules/analytics/server-side/details/ServerSideWidgetFunnel'
import { ServerSideWidgetResponses } from '~/modules/analytics/server-side/details/ServerSideWidgetResponses'
import { ServerSideWidgetRevenue } from '~/modules/analytics/server-side/details/ServerSideWidgetRevenue'
import { WithClassName } from '~/types/utils'

const ChartsContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > * + * {
    margin-top: 20px;
  }
`

const InlineLineChartContainer = styled.div`
  display: flex;

  > div {
    flex: 1;
  }

  & > * + * {
    margin-left: 20px;
  }
`

type ServerSideDetailChartsProps = WithClassName &
  Omit<WidgetProps, 'title' | 'icon' | 'refreshTrackingLabel'> & {
    isLoading: boolean
    error: boolean
    data: ServerSideMetricsDetailByTime
    currencySymbol: CurrencySymbol
    timezone: Timezone
    currentEpoch: DateTime
  }
export const ServerSideDetailCharts: FunctionComponent<ServerSideDetailChartsProps> = ({ className, ...props }) => (
  <ChartsContainer className={className}>
    <ServerSideWidgetRevenue {...props} />
    <LazyVisible minHeight={400}>
      <ServerSideWidgetResponses {...props} />
    </LazyVisible>
    <LazyVisible minHeight={300}>
      <InlineLineChartContainer>
        <ServerSideWidgetCPM {...props} />
        <ServerSideWidgetFunnel {...props} />
      </InlineLineChartContainer>
    </LazyVisible>
  </ChartsContainer>
)
